<template>
  <div>
    <v-card :width="$isMobile ? (windowInnerWidth * 0.98) - 80 : 734" style='border: none; background: #f3f4f6'>
      <v-card-text class='position-relative'>
        <div v-if='dataList.length > 0' class='mb-2 font-weight-bold'>
          {{ title }}
        </div>
        <!--        <div v-else class='mb-2 font-weight-bold'>-->
        <!--          {{ messages }}-->
        <!--        </div>-->
        <div v-if="modelType !== 'DeepSeek'" class='font-weight-bold'>
          <div>
            <span>会议地点：</span>
            <span>{{ meetingPlace }}</span>
          </div>
          <div>
            <span>开始时间：</span>
            <span>{{ messageData.startDateTime }}</span>
          </div>
          <div>
            <span>结束时间：</span>
            <span>{{ messageData.endDateTime }}</span>
          </div>
        </div>
        <div v-if='dataList.length > 0' class='mt-4 d-flex align-center flex-wrap'>
          <v-card
            v-for='(item, index) in dataList'
            :class="['mb-4', (index + 1) % 3 === 0 ? '' : 'mr-4']"
            :key='index'
            :width="$isMobile ? ((windowInnerWidth * 0.98) - 80 - 32) : 220"
          >
            <v-card-title class='pb-2 pa-3'>
              <div style='width: 100%' class='d-flex align-center justify-space-between'>
                <div class='d-inline-block text-truncate' style='width: 75%'>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on"
                            style='font-size: 18px; color: #000; font-weight: 500;line-height: 30px;'>
                        {{ item.roomName === 'King Landing' ? 'King\'s Landing' : item.roomName }}
                      </span>
                    </template>
                    <span>
                      {{ item.roomName === 'King Landing' ? 'King\'s Landing' : item.roomName }}
                    </span>
                  </v-tooltip>
                </div>
                <v-btn v-if='item.reservationFlag' rounded
                       disabled
                       small
                > {{ language === 'chinese' ? '已预订' : 'Reserved' }}
                </v-btn>
                <v-btn
                  v-else
                  :loading='item.reservationButtonLoading'
                  :disabled="item.reservationDisable"
                  rounded
                  color='#A100FF'
                  style='color: white'
                  depressed
                  small
                  @click="v1_reservation(item)"
                >
                  {{ language === 'chinese' ? '预订' : 'Reservation' }}
                </v-btn>
              </div>
              <div class='mt-1 d-inline-block text-truncate' style='margin-left: -3px'>
                <v-icon size='18' color='#606060'>{{ icons.mdiMapMarkerRadiusOutline }}</v-icon>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                       <span v-bind="attrs" v-on="on" style='color: #606060; font-size: 14px; font-weight: 400'>
                         {{ item.workplaceLocationValue }}
                       </span>
                  </template>
                  <span>
                    {{ item.workplaceLocationValue }}
                  </span>
                </v-tooltip>
              </div>
            </v-card-title>
            <v-img
              height='116'
              :src="item.roomImgUrl ? item.roomImgUrl : 'https://myops.accenture.cn/fs_prod/files/MYOPS/20250509/286fe1495c2824f05dad402b6bc58067.png'"
            >
              <div
                v-if="item.requireApproval === 'Y'"
                class='position-absolute pl-1 pr-2 pb-1 pt-1'
                style='background: #f0d6ff; border-bottom-right-radius: 20px'>
                <div class="d-flex align-center">
                  <v-img :src="require('@/assets/images/lock.png')" height="18" width="18"
                         style="margin-left: 2px"></v-img>
                  <span style='font-size: 12px; color: #b435ff; font-weight: 700'>
                    {{ language === 'chinese' ? '需要审批' : 'Approval required' }}
                  </span>
                </div>
              </div>
              <div
                v-if='item.capacity > 1'
                class='text-center mt-2 mr-2'
                style='margin-left: auto; width: 65px; height: 24px;border-radius: 12px;background: linear-gradient(180.00deg, #ececec 0%, #ececec 100%);'>
                <v-icon size='18' color='#606060' class='mr-1'>
                  {{ icons.mdiAccountMultipleOutline }}
                </v-icon>
                <span style='font-size: 12px; color: #000'>{{ item.capacity }}</span>
              </div>

              <div v-if="item.standard_services"
                   class='ml-1 d-flex align-center flex-wrap position-absolute' style="bottom: 2px">
                <div v-for="(service, index) in splitStandardServices(item.standard_services)"
                     :key="'StandardService-' + index" style="margin-right: 2px">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-img
                        v-bind="attrs"
                        v-on="on"
                        v-if="getStandardServiceByName(service)"
                        class='mb-1 cursor-pointer' width='20'
                        :src="require(`@/assets/images/standard_services/${getStandardServiceByName(service).iconName}`)">
                      </v-img>
                    </template>
                    <span>{{ getStandardServiceByName(service).name }}</span>
                  </v-tooltip>
                </div>
              </div>
            </v-img>
          </v-card>
        </div>
        <div v-if='!!list && list.length > 3' style='width: 100%'
             class='d-flex justify-start justify-space-between'>
          <v-pagination
            v-model='pageOption.page'
            :length='pageOption.length'
            color='#A100FF'
            light
            circle
            :total-visible='7'
            @input='pageChange'
            @next='pageChange'
            @previous='pageChange'
          ></v-pagination>
        </div>
        <div v-if='!!list && list.length === 0' class='text-center mt-3 mb-2' style='font-size: 14px'>
          <div style="font-size: 13px">
            <div>
              <div>Sorry, No available conference room / open workspace for booking.</div>
              <div> Please choose another date or time. Thank you.</div>
            </div>
          </div>
          <div class="mt-1">抱歉，当前时间没有可预订的会议室 / 工位，请选择其他日期和时间，谢谢。</div>
        </div>
      </v-card-text>
    </v-card>
    <message-box
      :msg-id='msgId'
      class='mt-2'
      @copy='copy'
      :message='messageData'
      :like-type='messageData.likeType'
      :isCustomCopyWriteText='true'
      @refreshAnswer="$emit('refreshAnswer', messageData)"
    ></message-box>
  </div>
</template>

<script>
import MessageBox from '../components/MessageBox.vue'
import { PageHandle } from '@/modules/chat/util/ChatBotUtil'
import RadioCircle from '../components/RadioCircle.vue'
import { mdiMapMarkerRadiusOutline, mdiAccountMultipleOutline } from '@mdi/js'
import { reservationPlaces, v1_reservationPlaces } from '@/modules/chat/api'
import { mapGetters } from 'vuex'
import { StandardServicesMix } from '@/modules/chat/view/chatbot/mixin/commonMixin'


export default {
  name: 'bookSeatCardList',
  components: { MessageBox, RadioCircle },
  mixins: [StandardServicesMix],
  props: {
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
    msgId: {
      type: Number,
      default: 0,
    },
    messageData: {
      type: Object,
      default: () => {
      },
    },
    immediatelyRender: {
      type: Boolean,
      default: false,
    },
    titlePrefix: {
      type: String,
      default: '',
    },
    language: {
      type: String,
      default: 'chinese',
    },
  },
  watch: {
    list: {
      handler(val) {
        this.pageHandleMethod(val)
      },
      immediate: true,
    },
    language: {
      handler(val) {
        this.title = val === 'chinese' ? '空闲会议室 / 工位如下表，请点击前往预订' : 'The available meeting rooms/open workspace are listed below. Please click to make a reservation'
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      chatSessionId: 'chat/chatSessionId',
      modelType: 'chat/modelType',
    }),
    windowInnerWidth() {
      return window.innerWidth
    },
  },
  data() {
    return {
      messages: '',
      showTable: false,
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      pageOption: {
        page: 1,
        total: 0,
        size: 3,
        length: 0,
      },
      dataList: [],
      title: '空闲会议室 / 工位如下表，请点击前往预订',
      pageHandle: null,
      icons: {
        mdiMapMarkerRadiusOutline,
        mdiAccountMultipleOutline,
      },
      meetingPlace: '',
    }
  },
  async mounted() {
    if (this.messageData.tipMsg) {
      this.title = this.messageData.tipMsg
    }
    this.meetingPlace = this.messageData.meetingPlace
    this.title = this.titlePrefix + this.title
    if (!this.immediatelyRender) {
      await this.displayMessageCharacterByCharacter(this.title)
    } else {
      this.showTable = true
    }
  },
  methods: {
    splitStandardServices(standardServices) {
      return standardServices.split(',')
    },
    // async reservation(item) {
    //   this.$set(item, 'reservationButtonLoading', true)
    //   let params = {
    //     requestType: item.requestType,
    //     firstStepBody: {},
    //   }
    //   params.firstStepBody.primary_building = item.workplaceLocationId
    //   params.firstStepBody.location = item.roomId
    //   params.firstStepBody.subject = '会议'
    //   params.firstStepBody.start = item.startTime
    //   params.firstStepBody.end = item.endTime
    //   const { data: { code, data, msg } } = await reservationPlaces(params)
    //   if (code === 200) {
    //     this.$message.success('预订成功')
    //     this.$set(item, 'reservationFlag', true)
    //   } else {
    //     this.$message.error(msg)
    //   }
    //   this.$set(item, 'reservationButtonLoading', false)
    //   this.$emit('reservation', { ...item, ...data })
    // },
    async v1_reservation(item) {
      this.$set(item, 'reservationButtonLoading', true)
      item.start = item.startTime
      item.end = item.endTime
      item.language = this.language
      const { data: { code, data, msg } } = await v1_reservationPlaces(item)
      if (code === 200) {
        // this.$message.success('预订成功')
        this.$set(item, 'reservationFlag', true)
      } else {
        // this.$message.error(msg)
        this.$set(item, 'reservationFlag', false)
      }
      this.$set(item, 'reservationButtonLoading', false)
      this.$emit('reservation', { ...item, ...data, errorMag: msg })
    },
    pageHandleMethod(valList = this.list) {
      this.pageHandle = new PageHandle(valList, this.pageOption.page, this.pageOption.size)
      this.pageOption.length = this.pageHandle.getPages()
      this.dataList = this.pageHandle.getCurrentPageList()
      this.dataList.forEach(item => {
        item.radioValue = false
        item.reservationDisable = this.messageData.componentDisabled
      })
    },
    radioChange(item) {
      this.dataList.forEach(el => {
        this.$set(el, 'radioValue', item.buildingId === el.buildingId)
      })
      this.$forceUpdate()
      this.$emit('selectBuildingChange', item)
    },
    pageChange() {
      this.pageHandleMethod()
    },
    async copy() {
      let copyTemplate = '城市\t\t\t' + '房间\t\n'
      const startIndex = (this.pageOption.page - 1) * this.pageOption.size
      const endIndex = startIndex + this.pageOption.size
      this.list.slice(startIndex, endIndex).forEach(item => {
        copyTemplate = copyTemplate + item.cityValue + '\t' + item.roomName + '\t\n'
      })
      await navigator.clipboard.writeText(copyTemplate)
      this.$message.success('复制成功')
    },
    displayMessageCharacterByCharacter(text) {
      var char = text.split('')
      for (let i = 0; i < char.length; i++) {
        setTimeout(() => {
          this.messages += char[i]
          this.$forceUpdate() // 强制视图更新以显示最新文本
          // this.scrollToBottom() // 确保新消息可见
        }, i * 150) // 1秒间隔
      }
      setTimeout(() => {
        this.showTable = true
        this.$emit('renderTableComplete')
      }, 2100)
      // this.showTable = true
    },
  },
}
</script>

<style scoped>
/* 图片纵向排列，超过三个图新起一列 */
/*.image-grid {*/
/*  margin-top: 10px;*/
/*  margin-left: -5px;*/
/*  display: grid;*/
/*  grid-template-columns: repeat(auto-fill, minmax(25px, 1fr));*/
/*  grid-template-rows: repeat(3, 1fr);*/
/*  grid-auto-flow: column;*/
/*}*/
</style>
